export const ShowFeaturesForInvestors = ({width}) => {
    return (
        <div className="content__body__element">
            <div className="content__body__features">
                <div className="content__body__features__element1 element">
                    <div className="content__body__features__title title1">Stärken Sie den regionalen Handel</div>
                    <div className="content__body__features__detail block1">
                        Der regionale Handel ist ein wichtiger Bestandteil unserer Gemeinschaft. Durch die Stärkung
                        des regionalen Handels können wir dazu beitragen, dass unsere Gemeinschaft gestärkt wird und
                        unsere lokale Wirtschaft gedeiht. Indem wir unsere Einkäufe lokal tätigen und kleine
                        Unternehmen unterstützen, können wir dazu beitragen, dass unsere Gemeinschaft lebendig und
                        wettbewerbsfähig bleibt.
                    </div>
                </div>

                <div className="content__body__features__element2 element">
                    <div className="content__body__features__title title2">Beleben wir die Städte</div>
                    <div className="content__body__features__detail block2">
                        "Beleben wir die Städte" - dieser Titel fordert uns dazu auf, gemeinsam unsere Städte wieder
                        zum Leben zu erwecken. Wir als Einwohner können durch unsere aktive Beteiligung und
                        Unterstützung lokaler Aktivitäten dazu beitragen, dass unsere Städte einladend und lebendig
                        sind. Eine lebendige Stadt schafft nicht nur ein angenehmes Umfeld zum Leben und Arbeiten,
                        sondern fördert auch das Miteinander und stärkt das Gemeinschaftsgefühl. Zusammen können wir
                        unsere Städte zu einem Ort machen, den wir gerne unser Zuhause nennen.
                    </div>
                </div>

                <div className="content__body__features__element1 element">
                    <div className="content__body__features__title title1">Förderen Sie die Digitalisierung Ihrer
                        Region
                    </div>
                    <div className="content__body__features__detail block1">
                        Als Unterstützer können Sie die Digitalisierung Ihrer Region fördern und damit einen
                        wichtigen Beitrag zur Stärkung der Wettbewerbsfähigkeit der lokalen Unternehmen leisten.
                        Ihre Hilfe ermöglicht es uns, unsere Region zukunftsorientiert zu gestalten und den
                        Anforderungen des digitalen Zeitalters gerecht zu werden. Werden Sie Teil dieser Entwicklung
                        und unterstützen Sie die Digitalisierung Ihrer Region.
                    </div>
                </div>

            </div>
        </div>
    )
}